import Axios from 'axios';
import config from '../config';
import { getAuthToken } from './authentication';


function axiosInstance (cType ) {

    const storedToken = getAuthToken();

    const baseURL = config.BASE_URL;
    const options = {
        baseURL,
        // timeout: 1000,
        headers: {
            'authorization': `Bearer ${storedToken}`,
            'Content-Type': cType
        }
    }

    const axiosInstance = Axios.create({...options});

    axiosInstance.interceptors.response.use(undefined, (err) => {
        return err;
    });

    return axiosInstance;
}

export function get(url, type = 'application/json') {
    const axios = axiosInstance(type);
    return axios.get(url);
}

export function post(url, type = 'application/json', requestData) {
    const axios = axiosInstance(type);
    return axios.post(url, requestData);
}

export function put(url, type = 'application/json', requestData) {
    const axios = axiosInstance(type);
    return axios.put(url, requestData);
}

export function del(url) {
    const axios = axiosInstance('delete');
    return axios.delete(url, 'application/json');
}
